import { useState, useEffect } from 'react';
import '../../css/App.css';
import { NavLink, useNavigate } from 'react-router-dom';

export const PolicyDisplayPg = ({filePath}) => {
    const navigate = useNavigate();
    const [policyHtml, setPolicyHtml] = useState('<p>Loading...</p>');

    useEffect(() => {
        fetch(filePath)
            .then(res => res.text())
            .then(html => setPolicyHtml(html))
            .catch(() => setPolicyHtml("<p style='color:red;'>Failed to load privacy policy.</p>"));
    }, []);

    const goBack = () => {
        if (window.opener || window.history.length === 1) {
            window.close(); // May not always succeed
        } else {
            navigate('/');
        }
    };

    return (
        <div>
            <div className='policy-wrapper'>
                <div
                    className='policy-container'
                    dangerouslySetInnerHTML={{ __html: policyHtml }}
                />
            </div>

            <div className='overlay_button_container' onClick={goBack}>
                <img src='/imgs/arrow.png' width='36' height='36' alt='back'></img>
            </div>
        </div>
    );
};
